import { makeHttpRequest } from "@/shared";

export const deleteKit = async (id) => {
    return (
        await makeHttpRequest({
            url: `/kit/${id}`,
            method: "DELETE",
        })
    ).data;
};
